.ipFields {
	display: grid;
	grid-template-columns: 1fr min(25%, 400px);
	gap: var(--size-3);
}

.addressSection {
	display: flex;
	flex-direction: column;
	gap: var(--size-4);
}

.sectionHeader {
	display: flex;
	flex-direction: column;
	gap: var(--size-1);
}

.sectionTitle {
	font-size: var(--text-subtitle-2);
	font-weight: 600;
	margin: 0;
}

.sectionDesc {
	font-size: var(--text-caption);
	color: var(--color-text-subtle);
	margin: 0;
}
